export interface Essay {
  slug: string;
  title: string;
  subtitle: string;
  author: string;
  date: string; // ISO
  dateDisplay: string;
  readingMinutes: number;
}

export const essays: Essay[] = [
  {
    slug: "the-second-loop",
    title: "The Second Loop",
    subtitle:
      "What the token capital era gets right, what it cannot see, and the asset no one can extract",
    author: "Kent H. Frazier",
    date: "2026-06-10",
    dateDisplay: "June 10, 2026",
    readingMinutes: 8,
  },
];

export const getEssay = (slug: string) => essays.find((e) => e.slug === slug);